<template>
  <div v-if="readable" :class="`input ${viewdata}`">
    <label class="real">{{fielddata.label}}</label>
    <div class="form-group">
			<input :class="`tgl tgl-light tgl-sm`"
				type="checkbox"
        :id="`tgl-${fielddata.name}-${itemdata[0] ? itemdata[0].id : 'new'}`"
        :disabled="!editable"
        :checked="!_.get(itemdata[0],  [fielddata.model, fielddata.name].filter(Boolean).join('.'))
                  || itemdata.length > 1  ? '' : 'checked'"
        @click="update"
        />
			<label
				:class="`tgl-btn tgl-btn-primary  ${editable ? '' : 'disabled'}`"
				:for="`tgl-${fielddata.name}-${itemdata[0] ? itemdata[0].id : 'new'}`"></label>
		</div>
  </div>
</template>

<script>
import _ from 'lodash';
import { global_emits } from '../../main';
import Data from '../../main';

export default {
	name: 'SwitchInput',
	props: {
		item: Array,
		field: Object,
		view: String,
	},
	computed: {
		// lodash in template
		_() {
			return _;
		},
	},
	watch: {
		item: function() {
			this.itemdata = this.item;
		},
	},
	data() {
		return {
			fielddata: this.field,
			itemdata: this.item,
			viewdata: this.view,
			editable: Data.fieldWriteable(this.field.id, Data),
			readable: Data.fieldReadable(this.field.id, Data)
		};
	},
	created() {
    // update field value on edit page save
    global_emits.$on('item_updated', (x) => {
      if(this.itemdata[0].id == parseInt( x.ids )){
        Object.keys(x.data).forEach( field_name => {
          this.itemdata[0][field_name] = x.data[field_name];
        });
      }
    });

		// / unique debounce update fn on each component life cycle
		const that = this;
		this.update = _.debounce(function(e) {
			if (that.viewdata == 'full') {
				return that.$emit('saveTrigger', {
					name: that.field.name,
					value: e.target.checked,
					model: that.field.model
				});
			}


			that.$Progress.start();
			that.$axios
				.put('/item', {
					batch: [that.item[0].id],
					update: {[that.field.name]: e.target.checked},
				})
				.then((response) => {
					// stay quiet
				})
				.catch((error) => {
					that.$notify({
						group: 'main',
						title: 'Something went wrong.',
						text: 'Please try again.',
						type: 'warn',
					});
					console.log(error);
				})
				.finally(()=>{
					that.$Progress.finish();
				});
		}, 500);
	},
	methods: {
		update() {},
	},
};
</script>

<style scoped lang="less">
  .input.full{
    height: 75px;
  }
  .inline label.real{
    display: none;
  }
  .inline{
    padding-top: 4px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .form-group{
      margin-bottom: 4px !important;
    }
  }
  .inline{
		.tgl+.tgl-btn {
	    width: 24px;
	    height: 14px;
		}
		label{
    	margin: auto;
  	}
	}




</style>
